import Link from "next/link";
import Image from "next/image";
import {grabImageURLFromGhostPost} from "../../utils/utility";

const List = props => {
    let regularposts = props.data.map(item => {
        let image = grabImageURLFromGhostPost(item.html, "onRegularList")
            ? grabImageURLFromGhostPost(item.html, "onRegularList")
            : item.feature_image;

        return (
            <Link key={item.id.toString()} href={props.path + item.slug} passHref>
                <div className="flex">
                    <div className="w-full">
                        <a href={props.path + item.slug}>
                            <Image
                                alt={item.title}
                                src={image ? image : "/images/rectangle3.jpg"}
                                width="142"
                                height="142"
                                layout="fixed"
                                objectFit="cover"
                                priority
                            />
                        </a>
                        <div className="text-base font-semibold font-body mb-1 max-w-[200px]">
                            {item.meta_title}
                        </div>
                        <div className="text-xs font-normal font-body max-w-[200px]">
                        {item.meta_description}
                        </div>
                    </div>

                </div>
            </Link>
        );
    });
    return (
        <section className="max-screen-w-2xl px-4 mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
                {regularposts}
            </div>
        </section>
    );
};
export default List;
